import axios from "axios";

export const ADMIN_TOKEN_KEY = "sb_admin_token";

export const adminApi = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/admin` });

adminApi.interceptors.request.use((config) => {
  const t = localStorage.getItem(ADMIN_TOKEN_KEY);
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});
